// Format phone numbers in xxx-xxx-xxxx format
export const phoneNumberFormatter = (str: string) => {
  if (str.length <= 3) {
    return str;
  } else if (str.length <= 6) {
    return `${str.substring(0, 3)}-${str.substring(3)}`;
  } else {
    return `${str.substring(0, 3)}-${str.substring(3, 6)}-${str.substring(6)}`;
  }
};

// Filter out all non digits from a string
export const cleanNumericInputValue = (str: string) => str.replace(/[^0-9]/g, '');

// Reduce arbitrary input to the 10 significant digits of a US phone number, dropping a leading
// country code ("1") so pasted values like "+1 (123) 456-7890" aren't mis-truncated. NANP area
// codes never start with 1, so stripping a leading 1 from 11 digits is unambiguous.
export const toUsPhoneDigits = (str: string) => {
  const digits = cleanNumericInputValue(str);
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  return national.slice(0, 10);
};

// Format a US phone number as (123) 456-7890, tolerating partial input during entry.
export const formatUsPhoneNumber = (str: string) => {
  const digits = toUsPhoneDigits(str);
  if (digits.length === 0) {
    return '';
  } else if (digits.length < 4) {
    return `(${digits}`;
  } else if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
};

// Capitalize first letter of string
export function capitalizeFirstLetter(value: string) {
  if (!value || value === '') return value;

  return value.charAt(0).toUpperCase() + value.slice(1);
}

// Generate Entity Id for page headers
export const formatEntityId = (id: string | number, prefix = 'F') => {
  const formattedId = `${prefix}${String(id).padStart(6, '0')}`;
  return formattedId;
};

export const usDollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatCurrency = (amount: number, shouldAppendAsterisk?: boolean) => {
  return `${usDollarFormatter.format(amount ?? 0)}${shouldAppendAsterisk ? '*' : ''}`;
};
